var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"WordCloudSummary"},[_c('block-title',{staticClass:"desktop:mb-8",attrs:{"title":"Concept analysis"}}),_c('WordCloud',{ref:"wordcloud",attrs:{"summary":"","cloud-data":_vm.data.cloud},on:{"reload":_vm.onReload}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }